import { getRequestCommonParameters } from '@lib/core/service/requests/api';

/**
 * List All Games
 */
export const apiUrlListAllRetailerGames = () => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();

  return `${retailerSlug}/${retailerLocationSlug}/game/board/`;
};

/**
 * Get Specific Game Details
 */
export const apiUrlGameDetails = (gameSlug: string) => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();

  return `/${retailerSlug}/${retailerLocationSlug}/game/board/${gameSlug}/`;
};

/**
 * List of all User's Game Enrollments
 */
export const apiUrlListUserGameEnrollments = () => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();

  return `${retailerSlug}/${retailerLocationSlug}/game/draw/`;
};

/**
 * Create Game Enrollment
 */
export const apiUrlCreateGameEnrollment = () => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();

  return `${retailerSlug}/${retailerLocationSlug}/game/draw/`;
};

/**
 * Get Specific Game Enrollments
 */
export const apiUrlGameEnrollments = (gameSlug: string) => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();

  return `${retailerSlug}/${retailerLocationSlug}/game/draw/${gameSlug}/`;
};

/**
 * Update Game Progress (Partial Update): totalScore or rewards
 */
export const apiUrlUpdateGameProgress = (gameSlug: string) => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();

  return `${retailerSlug}/${retailerLocationSlug}/game/draw/${gameSlug}/`;
};
